import {PricingPrice} from "./PricingPrice";
import {PricingPromoCodeDTO} from "./dto/PricingDTO";

export class PricingPromoCode
{
    private readonly _code: string
    private readonly _price: PricingPrice
    private readonly _discountLabel?: string

    constructor(promoCode: PricingPromoCodeDTO) {
        this._code = promoCode.code;
        this._price = new PricingPrice(promoCode.price);
        this._discountLabel = promoCode.discount_label ? promoCode.discount_label : null;
    }

    get code(): string {
        return this._code;
    }

    get price(): PricingPrice {
        return this._price;
    }

    get discountLabel(): string {
        return this._discountLabel;
    }

    hasDiscountLabel(): boolean {
        return this._discountLabel !== null;
    }
}
